import { useQuery } from '@tanstack/react-query';
import { useGql } from '@ah/design';
import { Header, PillTabs, PullToRefresh, type PillTab } from '@ah/design/mobile';
import { Newspaper } from 'lucide-react';
import { NEWS_LIST_QUERY, type NewsStoryListItem } from '../shared/index.ts';
import { NewsStoryRow, ListSkeleton, ErrorRetry } from './_parts.tsx';

const TABS: PillTab[] = [
  { to: '/news',        label: 'For You', end: true },
  { to: '/news/latest', label: 'Latest' },
  { to: '/news/seen',   label: 'Read' },
  { to: '/news/saved',  label: 'Saved' },
];

export function News() {
  const gql = useGql();
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['news', 'list'],
    queryFn: async () => {
      const res = await gql.request<{ newsStories: NewsStoryListItem[] }>(NEWS_LIST_QUERY);
      return res.newsStories;
    },
    refetchInterval: 60_000,
  });

  return (
    <div className="fixed inset-0 flex flex-col bg-background">
      <Header title="News" />
      <PillTabs tabs={TABS} />
      <PullToRefresh className="flex-1 px-3 py-3" onRefresh={() => refetch()}>
        {isLoading ? (
          <ListSkeleton variant="story" />
        ) : error ? (
          <ErrorRetry label="Could not load news." onRetry={() => refetch()} />
        ) : !data || data.length === 0 ? (
          <div className="text-center py-16 text-muted-foreground">
            <Newspaper size={32} className="mx-auto mb-2 opacity-50" />
            <p className="text-sm">No news stories yet — the crawler is warming up.</p>
          </div>
        ) : (
          <div className="space-y-3">
            {data.map((s) => <NewsStoryRow key={s.id} story={s} />)}
          </div>
        )}
      </PullToRefresh>
    </div>
  );
}
